(ns fen.pwa
  "Making this window installable: the worker that keeps the shell.

  Everything that decides what ento looks like as an app stands in
  public/manifest.webmanifest and public/sw.js - the browser reads both of
  them itself. What is left for the window to do is to say once that the
  worker exists.

  It is registered and then left alone. A new build brings a new worker
  which takes over as soon as it is installed, and no window is reloaded
  out from under anybody to make that happen: the shell is fetched from the
  network first, so a window that is online is already looking at the
  current one."
  (:require [kc.core :as kc]))

(defn install!
  "Register the worker, if this browser has them. Nothing here is waited
  for and nothing depends on it - ento works without a worker, it is just
  not installable and not there when the network is not."
  []
  (when-let [container (some-> js/navigator .-serviceWorker)]
    (-> (.register container "/sw.js" #js {:scope "/"})
        (.catch (fn [e] (kc/log-error "service worker not registered" e))))))
